import React from "react";
import swal from 'sweetalert'
import {useTranslation} from "react-i18next";
const EditCompanyHead = ({ show, handleClose, formData, handleInputChange, handleSave }) => {
    const {t} = useTranslation();
    const handleValidatedSave = () => {
        let errors = [];
        if(formData.zaxira > 2147483647) errors.push(t('translation:product_reserve_error', { reserve: formData.zaxira }))
        if(formData.geomembrana > 2147483647) errors.push(t('translation:geomembrana_error', {ga: formData.geomembrana}))
        if(formData.nasos_komplekt > 2147483647) errors.push(t('translation:pump_set_error', {pump_set: formData.nasos_komplekt}))
        if(formData.filtr_soni > 2147483647) errors.push(t('translation:filter_pcs_error', {filter_pcs: formData.filtr_soni}))
        if(formData.quvurlar > 2147483647) errors.push(t('translation:pipe_pcs_error', {pipe_pcs: formData.quvurlar}))
        if(formData.tomizgich_shlang > 2147483647) errors.push(t('translation:drip_hose_error', {drip_hose: formData.tomizgich_shlang}))
        if(formData.mutaxasisslar > 2147483647) errors.push(t('translation:specialists_error', {specialists: formData.mutaxasisslar}))
        if (errors.length > 0) {
            swal(t('error'), errors.join("\n"), "error");
            errors = []
            return;
        }
        handleSave();
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            id="editModal"
            tabIndex="-1"
            aria-labelledby="editModalLabel"
            style={{ display: show ? "block" : "none" , background: "rgba(0, 0, 0, 0.65)"}}
        >
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="editModalLabel">
                            {t('edit_information')}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="zaxira" className="form-label">
                                            {t('translation:product_reserve')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="zaxira"
                                            name="zaxira"
                                            value={formData?.zaxira || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('ga')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="geomembrana" className="form-label">
                                            {t('translation:geomembrana')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="geomembrana"
                                            name="geomembrana"
                                            value={formData?.geomembrana || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:geomembrana')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="nasos_komplekt" className="form-label">
                                            {t('translation:pump_set')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="nasos_komplekt"
                                            name="nasos_komplekt"
                                            value={formData?.nasos_komplekt || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:pump_set')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="filtr_soni" className="form-label">
                                            {t('translation:filter_amount')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="filtr_soni"
                                            name="filtr_soni"
                                            value={formData?.filtr_soni || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:filter_amount')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="quvurlar" className="form-label">
                                            {t('translation:pipes_pcs')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="quvurlar"
                                            name="quvurlar"
                                            value={formData?.quvurlar || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:pipes_pcs')}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="tomizgich_shlang" className="form-label">
                                            {t('translation:drip_hose')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="tomizgich_shlang"
                                            name="tomizgich_shlang"
                                            value={formData?.tomizgich_shlang || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:drip_hose')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="texnologiya_bazasi" className="form-label">
                                            {t('translation:base_of_construction')}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="texnologiya_bazasi"
                                            name="texnologiya_bazasi"
                                            value={formData?.texnologiya_bazasi || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:tech_base')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="mutaxasisslar" className="form-label">
                                            {t('translation:qualified_specialists')}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="mutaxasisslar"
                                            name="mutaxasisslar"
                                            value={formData?.mutaxasisslar || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('specialists')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="servis_markazlar" className="form-label">
                                            {t('service_center_established')}
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="servis_markazlar"
                                            name="servis_markazlar"
                                            value={formData?.servis_markazlar || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('service_center_established')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {t('translation:cancel')}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleValidatedSave}>
                            {t('translation:save')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditCompanyHead;
